export type ThemeColors = {
  background: string;
  accent1: string;
  accent2: string;
  accent3: string;
  font: string;
  subheaders: string;
  hovers: string;
  inputText: string;
};

export type Theme = {
  id: string;
  name: string;
  mode: 'light' | 'dark';
  colors: ThemeColors;
};

export const themes: Theme[] = [
  {
    id: 'squeaky-clean',
    name: 'Squeaky Clean',
    mode: 'light',
    colors: {
      background: '#fafafa',
      accent1: '#000000',
      accent2: '#000000',
      accent3: 'lavender',
      font: '#111827',
      subheaders: '#6366F1',
      hovers: '#4F46E5',
      inputText: '#111827'
    }
  },
  {
    id: 'deep-vintage',
    name: 'Deep Vintage',
    mode: 'light',
    colors: {
      background: '#fafafa',
      accent1: '#000000',
      accent2: '#000000',
      accent3: 'lavender',
      font: '#111827',
      subheaders: '#6366F1',
      hovers: '#4F46E5',
      inputText: '#111827'

    }
  },
  {
    id: 'cosmic-artistry-dark',
    name: 'Cosmic Artistry Dark',
    mode: 'dark',
    colors: {
      background: '#212A31',
      accent1: '#D3D9D4',
      accent2: '#124E66',
      accent3: '#fafafa',
      font: '#D3D9D4',
      subheaders: '#9CA3AF',
      hovers: '#6B7280',
      inputText: '#111827'
    }
  },
  {
    id: 'cosmic-artistry-light',
    name: 'Cosmic Artistry Light',
   mode: 'light',
    colors: {
      background: '#fafafa',
      accent1: '#000000',
      accent2: '#000000',
      accent3: 'lavender',
      font: '#111827',
      subheaders: '#6366F1',
      hovers: '#4F46E5',
      inputText: '#111827'

    }
  },
  {
    id: 'iconic',
    name: 'Iconic',
    mode: 'light',
    colors: {
      background: '#EBE9E1',
      accent1: '#D6536D',
      accent2: '#181818',
      accent3: '#EFB11D',
      font: '#E43D12',
      subheaders: '#C41E3A',
      hovers: '#BE123C',
      inputText: '#111827'
    }
  },
  {
    id: 'striking',
    name: 'Striking',
    mode: 'dark',
    colors: {
      background: '#0B0C10',
      accent1: '#45A29E',
      accent2: '#181818',
      accent3: '#45A29E',
      font: '#C5C6C7',
      subheaders: '#66E0DB',
      hovers: '#34D399',
      inputText: '#111827'
    }
  },
  {
    id: 'futuristic',
    name: 'Futuristic',
    mode: 'dark',
    colors: {
      background: '#0F292F',
      accent1: '#1CA4A8',
      accent2: '#181818',
      accent3: '#14A098',
      font: '#D1E8E2',
      subheaders: '#1CA4A8',
      hovers: '#14B8A6',
      inputText: '#111827'
    }
  },
  {
    id: 'minimal',
    name: 'Minimal',
    mode: 'light',
    colors: {
      background: '#EAE7DC',
      accent1: '#8E8D8A',
      accent2: '#8E8D8A',
      accent3: '#D8C3A5',
      font: '#4F4A41',
      subheaders: '#6B7280',
      hovers: '#4B5563',
      inputText: '#111827'
    }
  },
  {
    id: 'vivid',
    name: 'Vivid',
    mode: 'light',
    colors: {
      background: '#FFFFFF',
      accent1: '#44318D',
      accent2: '#181818',
      accent3: '#EBAACE',
      font: '#2A1B3E',
      subheaders: '#6366F1',
      hovers: '#4F46E5',
      inputText: '#111827'
    }
  }
];